import { PATHS } from "@/lib/router";
import {
  SurveysPage,
  SurveyTakePage,
  SurveyResponseDetailPage,
  CreateStandardSurveyPage,
  EditStandardSurveyPage,
  CreateCustomSurveyPage,
  EditCustomSurveyPage,
} from "./pages";

export const surveysRoutes = [
  {
    path: PATHS.SURVEYS,
    element: <SurveysPage />,
  },
  {
    path: PATHS.SURVEY_RESPONSE_DETAIL,
    element: <SurveyResponseDetailPage />,
  },
  {
    path: PATHS.STANDARD_SURVEY_NEW,
    element: <CreateStandardSurveyPage />,
  },
  {
    path: PATHS.STANDARD_SURVEY_EDIT,
    element: <EditStandardSurveyPage />,
  },
  {
    path: PATHS.CUSTOM_SURVEY_NEW,
    element: <CreateCustomSurveyPage />,
  },
  {
    path: PATHS.CUSTOM_SURVEY_EDIT,
    element: <EditCustomSurveyPage />,
  },
];

export const surveysPublicRoutes = [
  {
    path: `${PATHS.SURVEY_TAKE}/:surveyType/:surveyId`,
    element: <SurveyTakePage />,
  },
];
